import React from 'react';
import {Image, PageHeader} from 'antd';

const Forms = () => {
    return (
        <div>
            <PageHeader
                className="site-page-header"
                title="Формы"
            />
            <h3>Форма создания новой задачи - компонент <code>FormAddTask</code></h3><br/>
            <p>Создать новую задачу можно в режиме Admin по клику на кнопку Add new task в верхней части окна слева</p>
            <p>Кнопка открывает окно с двумя вкладками: в первой вкладке Add new task находится сама форма</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229406/documentation/Screenshot_2020-09-27_at_20.53.43_qrcale.png"
            /><br/><br/>
            <p>Обязательными при заполнении формы являются поля Name Author и Date</p>
            <p>При заполнении формы можно добавлять свой тег, менять цвет тега, добавлять несколько ссылок, отмечать на карте оффлайновое событие, прикреплять файлы</p>
            <p>Обратите внимание, добавление файлов имитируется, серверной части для реальной загрузки файлов в приложении нет</p>
            <p>Кнопка Submit отправляет post-запрос на сервер</p>
            <p>При отправке происходит проверка, и если сервер не вернул ошибку, появляется сообщение об успешной отправке</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601213462/docs/Screenshot_2020-09-27_at_16.28.47_s5pwyr.png"
            /><br/><br/>
            <p>Если отправка задачи не удалась, появляется сообщение об ошибке</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601213462/docs/Screenshot_2020-09-27_at_16.30.18_ptg9xi.png"
            /><br/><br/>
            <p>Во второй вкладке Task preview доступен просмотр заполняемой формы. Данные для предпросмотра собираются обработчиком onFieldsChange</p>
            <p>Если данные в форму еще не введены, отображается соответствующая картинка с предложением заполнить форму</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601213462/docs/Screenshot_2020-09-27_at_16.29.04_fqsnc0.png"
            /><br/><br/>
            <p>По мере ввода данных в форму при переходе на вкладку Task preview данные отображаются так, как они будут выглядеть на странице задачи</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229407/documentation/Screenshot_2020-09-27_at_20.55.02_dbohxl.png"
            /><br/><br/>
            <h3>Форма редактирования задачи компонент <code>FormEditTask</code> в компоненте <code>TaskPageDrawer</code></h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229407/documentation/Screenshot_2020-09-27_at_20.55.49_nnvmiz.png"
            /><br/><br/>
            <p>Форма редактирования задачи доступна в окне задачи в режиме Admin</p>
            <p>При нажатии на кнопку с иконкой редактирования окно задачи заменяется формой с подставленными из текущей задачи полями </p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229407/documentation/Screenshot_2020-09-27_at_20.56.28_gm3rfx.png"
            /><br/><br/>
            <p>Submit отправляет put-запрос на сервер</p>
            <p>Cancel возврашает к форме просмотра задачи</p>
        </div>
    );
};

export default Forms;